import { RadioButtonValgModel } from '../../Shared/Scripts/Components/RadioButtonValg';
import VeilederVgsUrDto from '../Models/VeilederVgsUrDto';

const studieforbedrende = 'a1-studieforbedrende';
const yrkesfag = 'a2-yrkesfag';
const pabygg = 'a3-pabygg';

const aValg: RadioButtonValgModel<VeilederVgsUrDto>[] = [
    {
        id: 'a1',
        value: studieforbedrende,
        tekst: 'valgStudieforberedende',
    },
    {
        id: 'a2',
        value: yrkesfag,
        tekst: 'valgYrkesfag',
    },
    { id: 'a3', value: pabygg, tekst: 'valgPabygging' },
];

export default {
    a1_studieforbedrende: studieforbedrende,
    a2_yrkesfag: yrkesfag,
    a3_pabygg: pabygg,
    aValg,
};
